import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function phasesReducer(state = initialState.phases, action) {

    const mergeInPhase = (phases, phaseUpdate) => {
        const phasesMinusStaleData = phases.filter(phase => phase.id !== phaseUpdate.id);       
        return phasesMinusStaleData.concat(phaseUpdate);
    }

     const deletePhase = (current, id) => {
        return current.filter(phase => phase.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_PHASE_SUCCESS:
        case types.UPDATED_PHASE_SUCCESS:
            return mergeInPhase(state, action.phase);
            case types.DELETED_PHASE:      
            return deletePhase(state, action.phase.id);      
        case types.DELETED_PHASE_INCOMING:  
        case types.UPDATED_PHASE_INCOMING:
            return deletePhase(state, action.payload.id);    
        default:
            return state;
    }
}